<style scoped lang="less">
.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.courselist {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	background-color: #fff;
	padding: 20px;

	.courseitem {
		width: 19%;
		border: 1px solid #ccc;
		padding-bottom: 20px;
		margin-right: 10px;
		margin-top: 20px;
		img {
			width: 100%;
			height: 200px;
		}

		.card-text {
			// width: 25%;
			width: auto;
			min-width: 25%;
			max-width: 40%;
		}

		.courseitemcontent {
			padding: 0 10px;
			p:first-child {
				color: #4081b8;
				font-size: 18px;
			}
			p {
				font-size: 16px;
				margin: 10px 0;
			}

			.btnsgo {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.btngo {
					width: 30%;
					border: 1px solid;
					text-align: center;
					height: 30px;
					line-height: 30px;
					border-radius: 5px;
					color: #fff;
					background-color: #59a959;
				}
			}
		}
	}
}

.elpagian {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	// margin: 20px 0;
	background-color: #fff;
	padding: 20px 0;
}
</style>
<template>
	<div>
		<titles titlename="我的课程" titlecontent="这里可以看到我的课程" :mbx="paths"></titles>
		<div class="manageselect">
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.ProfessionalID" placeholder="请选择专业" @change="getpolist()">
						<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
					</el-select>
				</div>
			</div>
			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.PR_GUID" placeholder="请选择岗位">
						<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="sclectlable">
				<div>
					<el-select clearable v-model="pagesobj.Inspectionlevel" clearable placeholder="请选择等级">
						<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
					</el-select>
				</div>
			</div>

			<div class="primarybtn" @click="getcourse()"><el-button type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>

		<div class="courselist">
			<el-empty style="width: 100%;" v-if="lists.length == 0" description="暂无课程,请进入首页学习课程"></el-empty>

			<div class="courseitem" v-for="(item, index) in lists" :key="item.CO_GUID">
				<img v-if="item.CO_CoverImgUrl" :src="item.CO_CoverImgUrl" alt="" srcset="" />
				<img v-else src="http://www.hngtsd.net:9999/images/ykc/ykc1.png" alt="" srcset="" />
				<div class="courseitemcontent">
					<p>{{ item.CO_CoursesName }}</p>
					<p>学习进度</p>
					<div><el-progress text-color="#fff" status="success" :text-inside="true" :stroke-width="26" :percentage="item.GT_StudyProgress"></el-progress></div>
					<p style="background: #efae43;" class="card-text text-grey-d1 mt-2 color_red">
						<span class="badge bgc-warning brc-warning text-white badge-xm arrowed arrowed-in-right">课时：{{ item.CO_Learning }}</span>
					</p>

					<div class="btnsgo" @click="goexasmin(item)"><div class="btngo">进入学习</div></div>
				</div>
			</div>
		</div>
		<div class="elpagian">
			<el-pagination
				@current-change="changecurr"
				background
				layout="prev, pager, next"
				:page-size="pagesobj.pageSize"
				:total="totalall"
				:current-page="pagesobj.pageIndex"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getGetProfList, getPositionList, changeGradeGet, MyCourses } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	data() {
		return {
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				PCR_GUID: '',
				PR_GUID: '',
				SPA_PaperTitle: '',
				IL_GUID: '',
				pro_guid: '',
				kc_jd: '',
				Inspectionlevel: '',
				CourseName: '',
				ProfessionalID: ''
			},
			totalall: 10,
			// 标题
			paths: [
				{
					path: '/homesview/mycourse',
					name: '我的课程'
				}
			],
			prolist: [],
			polist: [],
			gradeget: [],
			lists: []
		};
	},
	mounted() {
		this.getprolist();
		this.getgrads();
		this.getcourse();
	},
	methods: {
		changecurr(val) {
			this.pagesobj.pageIndex = val;
			this.getcourse();
		},
		getcourse() {
			MyCourses(this.pagesobj).then(res => {
				this.lists = res.data.data.list;
				this.totalall = res.data.data.totalCount;
			});
		},
		goexasmin(itm) {
			this.$router.push('/cours/clouddetea?coguid=' + itm.CO_GUID);
		},
		getprolist() {
			getGetProfList().then(res => {
				// console.log(res.data.data)
				if (res.data.code > 0) {
					this.prolist = res.data.data;
					if (this.pagesobj.pro_guid !== '') {
						this.getpolist();
					}
				}
			});
		},
		getpolist() {
			getPositionList(this.pagesobj.pro_guid).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		}
	},
	components: {
		titles
	}
};
</script>
